const PRIMARY_KEY_NAME = "id";
const TYPENAME_KEY_NAME = "__typename";
const NIL_UUID = "00000000-0000-0000-0000-000000000000";
export {
  NIL_UUID,
  PRIMARY_KEY_NAME,
  TYPENAME_KEY_NAME
};
//# sourceMappingURL=bindingTypes.js.map
